import { buttons } from './buttons';
import { fonts } from './fonts';
export var designTokens = {
  colors: {
    buttons: buttons
  },
  fonts: fonts
};